/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, { Component } from 'react'
import SidebarMenuRouters from '../../routers/routers.js'
import Header from '../../containers/header.js'
import Places from '../../containers/places.js'
import PropTypes from 'prop-types'

import { Redirect } from 'react-router'

class Direction extends Component {

  constructor (props) {
    super(props)
    let userData = JSON.parse(localStorage.getItem('userData'))
    this.state = {userData: userData, rol: userData.rol}
  }

  render () {
    let result

    if (this.state.rol === 'direction') {
      result = <div>
        <SidebarMenuRouters profile="/direction-home/" place="" profileHome={'/direction-home'}/>
        <Header userName={this.state.userData.name}/>
        <Places profile="/direction-home/"/>
      </div>
    } else {
      result = <Redirect to={'/'}/>
    }

    return (
      <div>
        {result}
      </div>
    )
  }
}

Direction.childContextTypes = {
  type: PropTypes.string
}

export default Direction



// WEBPACK FOOTER //
// ./src/scene/profile/direction.js